import _extends from "@babel/runtime/helpers/extends";
import { useCombinedThemeMode } from "@smartsheet/sds-theme-internal";
import React, { forwardRef } from "react";
import { TabUnderlineStyled } from "./TabUnderlineStyled";
export var TabUnderline = /*#__PURE__*/forwardRef(function (props, ref) {
  var themeMode = useCombinedThemeMode();
  return /*#__PURE__*/React.createElement(TabUnderlineStyled, _extends({
    themeMode: themeMode,
    ref: ref
  }, props));
});
TabUnderline.displayName = "TabUnderline";
//# sourceMappingURL=TabUnderline.js.map